// extracted by mini-css-extract-plugin
export default {"formContainer":"forgotPassword_formContainer__Tyen0","MuiGrid-container":"forgotPassword_MuiGrid-container__vV4K+"};